(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('BlackoutPeriodSearch', BlackoutPeriodSearch);

    BlackoutPeriodSearch.$inject = ['$resource'];

    function BlackoutPeriodSearch($resource) {
        var resourceUrl =  'api/_search/blackout-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
